export default __webpack_public_path__ + "static/brass-sonntag-preview-9c72c8d0aabcdb7e67d2dac53cadbb12.jpg";